export default __webpack_public_path__ + "static/media/building-design.66e7fcdc.jpg";